import Layout from "@/components/Layout";
import LibraryListPage from "@/pages/LibraryListPage";
import { useTour } from "@reactour/tour";
import { withTour } from "@/components/withTour";
import { useTranslation } from "react-i18next";

const useTourSteps = () => {
  const { t } = useTranslation();
  return [
    {
      selector: '#library-add-video',
      content: t('library.tour.addVideo'),
      position: 'bottom',
    },
    {
      selector: '#library-hero-steps',
      content: t('library.tour.steps'),
      position: 'top',
    },
    {
      selector: '#library-explore-community',
      content: t('library.tour.exploreCommunity'),
      position: 'bottom',
    },
    {
      selector: '#help-button',
      content: t('library.tour.helpButton'),
      position: 'bottom',
    },
  ];
};

const LibraryContent = () => {
  const { setIsOpen, setCurrentStep } = useTour();

  const startTour = () => {
    setCurrentStep(0);
    setIsOpen(true);
  };

  return (
    <Layout onStartTour={startTour}>
      <LibraryListPage />
    </Layout>
  );
};

const LibraryWrapper = () => {
  const tourSteps = useTourSteps();
  const WrappedComponent = withTour(LibraryContent, 'autoclipper-library-tour-seen', tourSteps);
  return <WrappedComponent />;
};

const Library = LibraryWrapper;

export default Library;
